<template>
    <solid-box
        :priceRate="tradeSum.priceRate[transferVariety]"
        :title="moduleName"
    >
        <div class="list">
            <el-tabs v-model="activeName" @tab-click="tabClick">
                <el-tab-pane
                    v-for="(item, index) in list"
                    :label="item.title"
                    :name="item.name"
                    :key="`${item.type}-${index}`"
                ></el-tab-pane>
            </el-tabs>
            <el-carousel
                arrow="never"
                ref="carousel"
                indicator-position="none"
                @change="tabChange"
            >
                <el-carousel-item
                    v-for="item in list"
                    :name="item.name"
                    :key="item.type"
                >
                    <div class="item-wrap">
                        <div class="item _item1">
                            <div class="label">
                                {{ tradeSum.ctype }}{{ item.label1 }}
                            </div>
                            <div class="number">
                                {{
                                    tradeSum.money[
                                        `tradeAmount_${transferVariety}_${item.type}`
                                    ] || 0
                                }}
                                <span class="unit">{{ item.unit1 }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-wrap">
                        <div class="item _item2">
                            <div class="label">
                                {{ tradeSum.ctype }}{{ item.label2 }}
                            </div>
                            <div class="number">
                                {{ item.count || 0 }}
                                <span class="unit">{{ item.unit2 }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="item-wrap">
                        <div class="item _item3">
                            <div class="label">
                                {{ tradeSum.ctype }}{{ item.label3 }}
                            </div>
                            <div class="number">
                                {{ item.number || 0 }}
                                <span class="unit">{{ item.unit3 }}</span>
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </solid-box>
</template>

<script>
import SolidBox from '@/components/SolidBox'
import eventHub from '@/utils/eventHub'
import env from '@/config/env'

/**
 * 集体经营性资产 || 国有资产
 */
export default {
    props: {
        tradeSum: {
            type: Object,
            default: () => {}
        },
        moduleName: {
            type: String,
            default: ''
        },
        transferVariety: {
            type: String,
            default: ''
        }
    },
    components: {
        SolidBox
    },
    data() {
        return {
            activeName: '',
            list: [
                {
                    title: '房屋',
                    name: '0',
                    type: 'FW',
                    label1: '金额',
                    label2: '笔数',
                    label3: '面积',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '平方米'
                },
                {
                    title: '商铺',
                    name: '1',
                    type: 'SP',
                    label1: '金额',
                    label2: '笔数',
                    label3: '面积',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '平方米'
                },
                {
                    title: '建筑物',
                    name: '2',
                    type: 'JZW',
                    label1: '金额',
                    label2: '笔数',
                    label3: '面积',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '平方米'
                },
                {
                    title: '机器设备',
                    name: '3',
                    type: 'JQSB',
                    label1: '金额',
                    label2: '笔数',
                    label3: '数量',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '台'
                },
                {
                    title: '运输工具',
                    name: '4',
                    type: 'YSGJ',
                    label1: '金额',
                    label2: '笔数',
                    label3: '数量',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '辆'
                }
            ]
        }
    },
    mounted() {
        // 2022-07-27 针对湖南线上大屏做的特殊处理
        // 2023-05-26 全国大屏
        if (
            this.$route.params.id === env.HNLOCID ||
            this.$route.params.id === 'zhongguo'
        ) {
            this.list = [
                {
                    title: '房屋',
                    name: '0',
                    type: 'FW',
                    label1: '金额',
                    label2: '笔数',
                    label3: '面积',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '平方米'
                },
                {
                    title: '商铺',
                    name: '1',
                    type: 'SP',
                    label1: '金额',
                    label2: '笔数',
                    label3: '面积',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '平方米'
                },
                {
                    title: '机器设备',
                    name: '2',
                    type: 'JQSB',
                    label1: '金额',
                    label2: '笔数',
                    label3: '数量',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '台'
                },
                {
                    title: '运输工具',
                    name: '3',
                    type: 'YSGJ',
                    label1: '金额',
                    label2: '笔数',
                    label3: '数量',
                    unit1: '万元',
                    unit2: '笔',
                    unit3: '辆'
                }
            ]
        }

        eventHub.$on('tradeChange', (tradeSum) => {
            let expandVoList =
                this.$route.name === 'haiken'
                    ? tradeSum.count.expandVoGyzcList
                    : tradeSum.count.expandVoList
            for (let i = 0; i < expandVoList.length; i++) {
                for (let j = 0; j < this.list.length; j++) {
                    if (this.list[j].title === expandVoList[i].typeName) {
                        this.list[j].count = expandVoList[i].count
                        this.list[j].number = expandVoList[i].number
                    }
                }
            }
        })
    },
    methods: {
        tabChange(val) {
            this.activeName = val + ''
        },
        tabClick() {
            this.$refs.carousel.setActiveItem(this.activeName)
        }
    }
}
</script>

<style scoped>
/deep/ .el-tabs__nav-wrap::after {
    background: unset;
}
/deep/ .el-tabs__header {
    margin-bottom: 10px;
}
/deep/ .el-tabs__item {
    font-size: 18px;
    color: #40b9f6;
    padding: 0 8px;
}
/deep/ .el-tabs__item.is-active {
    color: #40b9f6;
}
/deep/ .el-tabs__content {
    background: #007aff;
}
/deep/ .el-tabs__nav {
    float: right;
}
/deep/ .el-carousel__container {
    height: 190px;
}
</style>
<style lang="scss" scoped>
.hader {
    font-size: 18px;
    color: #ffffff;
    margin: 14px auto 0;
    width: 154px;
    height: 25px;
    line-height: 25px;
    background-size: 100% 5px;
    background-repeat: no-repeat;
    background-position: center center;
    background-image: url('../../../assets/images/collective_management_head_bg.png');
    text-align: center;
}

.list {
    width: calc(100% - 80px);
    padding: 0 40px;
    .item-wrap {
    }

    .item {
        margin-bottom: 14px;
        width: 100%;
        height: 50px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        padding: 10px 25px 0 35px;
        box-sizing: border-box;
        &._item1 {
            background-image: url('../../../assets/images/collective_management_item_bg1.png');
        }
        &._item2 {
            background-image: url('../../../assets/images/collective_management_item_bg2.png');
        }
        &._item3 {
            background-image: url('../../../assets/images/collective_management_item_bg3.png');
        }
        > .label {
            font-size: 16.54px;
            color: #ffffff;
            line-height: 24px;
        }

        > .number {
            margin-left: auto;
            display: flex;
            align-items: center;
            font-size: 24px;
            color: #ffffff;
            text-align: right;
            line-height: 30px;

            > .unit {
                font-size: 14px;
                color: #ffffff;
                text-align: justify;
                line-height: 30px;
                margin-left: 4px;
            }
        }
    }
}
</style>
